module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buettenhardt-99068709c5d60c10ddba325e70b90598.png";